import React, { Component } from 'react'
import PropTypes from 'prop-types'


class Example extends Component {
	render() {
		return (
			<h1>
				Example Component
			</h1>
		)
	}
}

const { string } = PropTypes

Example.propTypes = {
	text: string
}

export default Example
